export default __webpack_public_path__ + "static/media/github.c20f38ca.svg";